import React from 'react';
import TemplateDetailsHeader from './TemplateDetailsHeader';
import TemplateMobileRailTrigger from './TemplateMobileRailTrigger';

const TemplateDetailsContentShell = ({
    t,
    details,
    edit,
    loading,
    alert,
    navigate,
    isWebDashboardTabActive,
    isDashboardExpandedActive,
    isMobileTemplateDetailsLayout,
    setIsMobileDetailsRailOpen,
    canOpenReportDialog,
    canAddTemplate,
    canAddTemplateExamples,
    isCompactHeaderActions,
    isHeaderActionsMenuOpen,
    setIsHeaderActionsMenuOpen,
    headerActionsMenuRef,
    downloadReportActionLabel,
    setDownloadReportState,
    duplicateTemplate,
    openMarkAsExampleDialog,
    handleCancelEdit,
    isApplyDisabled,
    updateTemplate,
    setEdit,
    dashboardBodyRef,
    children,
}) => (
    <div className={`details-content${isWebDashboardTabActive ? ' td-details-content-dashboard' : ''}${isDashboardExpandedActive ? ' dashboard-edit-expanded-content' : ''}`}>
        <TemplateMobileRailTrigger
            isMobileTemplateDetailsLayout={isMobileTemplateDetailsLayout}
            setIsMobileDetailsRailOpen={setIsMobileDetailsRailOpen}
        />
        <TemplateDetailsHeader
            t={t}
            details={details}
            edit={edit}
            loading={loading}
            alert={alert}
            navigate={navigate}
            isDashboardExpandedActive={isDashboardExpandedActive}
            canOpenReportDialog={canOpenReportDialog}
            canAddTemplate={canAddTemplate}
            canAddTemplateExamples={canAddTemplateExamples}
            isCompactHeaderActions={isCompactHeaderActions}
            isHeaderActionsMenuOpen={isHeaderActionsMenuOpen}
            setIsHeaderActionsMenuOpen={setIsHeaderActionsMenuOpen}
            headerActionsMenuRef={headerActionsMenuRef}
            downloadReportActionLabel={downloadReportActionLabel}
            setDownloadReportState={setDownloadReportState}
            duplicateTemplate={duplicateTemplate}
            openMarkAsExampleDialog={openMarkAsExampleDialog}
            handleCancelEdit={handleCancelEdit}
            isApplyDisabled={isApplyDisabled}
            updateTemplate={updateTemplate}
            setEdit={setEdit}
        />
        <div
            ref={dashboardBodyRef}
            className={`details-body td-details-body-dashboard${isDashboardExpandedActive ? ' dashboard-edit-expanded-body' : ''}`}
        >
            <div className={`details-tab-content${isWebDashboardTabActive ? ' td-details-tab-content-dashboard' : ''}`}>
                {children}
            </div>
        </div>
    </div>
);

export default TemplateDetailsContentShell;
